import { BreadCrumbs } from '@/interfaces/product';
import { capitalizeFirstLetter } from '@/utils/helper';
import CustomLink from '@/components/CustomLink';
import { twMerge } from 'tailwind-merge';

const Breadcrumb = ({ className = '', bred }: { className: string; bred: BreadCrumbs[] }) => {
  const cl = twMerge('lg:mb-5 mb-8 flex text-[1.2rem]', className);

  return (
    <div className={cl}>
      {bred && (
        <>
          <div className="mr-2">
            <CustomLink prefetch={false} href="/" className="underline-custom mr-2 font-medium [--underline-offset:3px]">
              Home
            </CustomLink>
            /
          </div>
          {bred.map((bredItem, index) => (
            <div className="mr-2" key={bredItem.SeName}>
              <CustomLink
                href={`/${bredItem.IsCategory ? 'category' : 'brand'}/${bredItem.SeName}`}
                className="underline-custom mr-2 font-medium [--underline-offset:3px]"
              >
                {bredItem.Name && capitalizeFirstLetter(bredItem.Name)}
              </CustomLink>
              <span className={index === bred.length - 1 ? 'hidden' : ''}>/</span>
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default Breadcrumb;
